import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Header from '../../components/Bar/Header'
import Footer from '../../components/Footer/Footer'
import { useParams } from 'react-router-dom'
import BannerCultureTour from '../../components/Servicepages/BannerCultureTour'
import ServicePageCultureTour from '../../components/Servicepages/ServicePageCultureTour'


const CultureTour = () => {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
   const { titre } = useParams();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeOut' }}
    >
  
      <Header />
      <BannerCultureTour titre={titre} />

      <ServicePageCultureTour titre={titre} />
     
    
     
      <Footer />
    </motion.div>
  )
}

export default CultureTour
